import type { Metric, Timeseries } from "@fiberplane/charts";

import { TooltipBody } from "./TooltipBody";
import { TooltipCaption } from "./TooltipCaption";

type Props = {
  metric: Metric;
  timeseries: Timeseries;
};

export function TimeseriesTooltipContent({
  timeseries,
  metric,
}: Props): JSX.Element {
  return (
    <table>
      <TooltipCaption>{metric.time}</TooltipCaption>
      <thead>
        <tr>
          <th>{timeseries.name || "value"}</th>
          <th>{metric.value}</th>
        </tr>
      </thead>
      <TooltipBody labels={timeseries.labels} />
    </table>
  );
}
